<template>
  <div class="page">

    <img src="@/assets/010.jpg" class="banner" alt="banner" />
    <img src="@/assets/011.jpg" class="banner" alt="banner" />


  </div>
</template>

<script>
export default {
  name: 'Page3'
}
</script>

<style scoped>
.banner{
  max-width: 100%;
   
}
</style>